import React,{ Component } from 'react';
import { browserHistory } from 'react-router';
import $ from 'jquery';
import { ShareButtons, generateShareIcon } from 'react-share';
import { Panel,Breadcrumb } from 'react-bootstrap';
import WebHeaderInner from './../Common/WebHeaderInner.js';
import WebFooter from './../Common/WebFooter.js';
// import Footer from './Footer.js';
const {FacebookShareButton,GooglePlusShareButton,TwitterShareButton} = ShareButtons;
const FacebookIcon = generateShareIcon('facebook');
const TwitterIcon = generateShareIcon('twitter');
const GooglePlusIcon = generateShareIcon('google');
const  baseUrl='https://aquadeals.in/admin/web3/user/';
export default class Web_ShareEarn extends Component{
	constructor(props){
		super(props);
		this.state={
			balance:0,
			code:'',
			refferal_cash:0,
			frnd_cash:0,
			tot_amt:0,
			image:'',
			status:'',

			open: true,
			open2:true,
			shareUrl: '',
			msg: '',
			url:'',
		};
		this.getShareDetails=this.getShareDetails.bind(this);
		this.shareEarn=this.shareEarn.bind(this);
	}
	componentDidMount()
	{
		localStorage.removeItem('w_r_s_dt');
    localStorage.removeItem('w_r_e_coupon_dt');
    localStorage.removeItem('w_r_e_s_dt');
    localStorage.removeItem('web_mycart');
    localStorage.removeItem('w_r_enq_seller_page');
    localStorage.removeItem('w_r_p_dt');
    localStorage.removeItem('w_r_e_p_dt');
    localStorage.removeItem('web_ofr_page');
    localStorage.removeItem('profile');
    localStorage.removeItem('myaquacash');
    
    localStorage.removeItem('checkout');
    localStorage.removeItem('order_details');
    localStorage.removeItem('myorders');
    localStorage.removeItem('w_r_p_deals');
    localStorage.removeItem('seed');
    localStorage.removeItem('nauplii');
    localStorage.removeItem('subdeals');
    localStorage.removeItem('shipping');
    localStorage.removeItem('notifications');
    localStorage.removeItem('web_quickcart');
    localStorage.removeItem('view_rating');
    localStorage.removeItem('w_modal_seed');
    localStorage.removeItem('w_r_seed_deals');
    localStorage.removeItem('w_r_e_p_dt');
    localStorage.removeItem('w_modal_details');
    localStorage.removeItem('offers');
    localStorage.removeItem('give_rating');
    localStorage.removeItem('pprice');
    localStorage.removeItem('sprice');
    localStorage.removeItem('seed_id');
    localStorage.removeItem('h_type');
    localStorage.removeItem('web_pro_ofr_dtls');
    localStorage.removeItem('web_wishlist');
    localStorage.removeItem('web_brand_details');

    localStorage.removeItem('m_r_s_dt');
    localStorage.removeItem('m_r_e_coupon_dt');
    localStorage.removeItem('m_r_e_s_dt');
    localStorage.removeItem('mob_mycart');
    localStorage.removeItem('m_r_enq_seller_page');
    localStorage.removeItem('m_r_p_dt');
    localStorage.removeItem('m_r_e_p_dt');
    localStorage.removeItem('ofr_page');
    localStorage.removeItem('pro_ofr_dtls');

    localStorage.removeItem('share_earn');
    localStorage.removeItem('my_orders');
    localStorage.removeItem('m_r_p_deals');
    localStorage.removeItem('mob_quickcart');
    localStorage.removeItem('partner_deals');



		if(screen.width < 800)
		{
			window.location.href="/share_earn";
		}
		// localStorage.setItem('web_share_earn','/web/share_earn');
		if(!localStorage.user_id && !localStorage.token)
		{
			localStorage.setItem('web_share_earn','/web/share_earn');
			browserHistory.push('/web/login');
		}
		else
		{
			this.getShareDetails();
			this.shareEarn();	
		}
	}
	shareEarn()
	{	
		this.setState({
			open: !this.state.open,
		});

		var data1={from:'desktop_web',id:localStorage.getItem('user_id'),token:localStorage.getItem('token')};
		var data2=JSON.stringify(data1);
		$.ajax({
			method:'post',
			url:baseUrl+'shareAppurl',
			dataType: 'json',
			data:{req:data2},
			success:function(data)
			{
				this.setState({
					msg:data.share_data,
					url:data.tinyurl,
				});
			}.bind(this),
			error:function(err)
			{
				
			}
		});
	}
	getShareDetails()
	{
		if(localStorage.user_id)
		{
			var uid=localStorage.user_id;
		} 
		else
		{
			 uid= 0;
		}
		var data1={from:'desktop_web',id:uid,token:localStorage.getItem('token')};
		var data2=JSON.stringify(data1);
		$.ajax({
			method:'post',
			url:baseUrl+'referAndEarn',
			dataType: 'json',
			data:{req:data2},
			success: function(data)
			{
				this.setState({
					balance:data.balance,
					code:data.code,
					refferal_cash:data.refferal_cash,
					frnd_cash:data.frnd_cash,
					tot_amt:data.tot_amt,
					image:data.image,
					status:data.status,
				});
			}.bind(this),
			error:function(err)
			{
				console.log(err);
			}
		});
	}
	render()
	{
		document.title="Share & Earn | AquaDeals";
		var msg=this.state.msg;
		var url=this.state.url;
		// var sh_url=this.state.msg;
		var description=this.state.msg;
		if(this.state.msg !=='')
		{
			var title=this.state.msg;
		}
		else
		{
			// title="Hey! Use my code "+code+ "to signup and get Rs2000 AquaCash. Click https:\/\/goo.gl\/gvP4pb to download the AquaDeals Android app";
			title=msg;
		}
	return(
       <div className="web_Deals web_share_earnpage">
        <WebHeaderInner /> 
         <div className="container">  
           <div className="clr">&nbsp;</div>
           <div className="clr">&nbsp;</div>
           <div className="clr">&nbsp;</div>
           <div className="clr">&nbsp;</div>
           <div className="clr">&nbsp;</div>
           <div className="row container"  style={{marginLeft:0}}>
             <Breadcrumb className="webshareEarn_breadcrumb">
			   <Breadcrumb.Item href="/web/home" >Home</Breadcrumb.Item>
			   <Breadcrumb.Item active>
			     Share & Earn
			   </Breadcrumb.Item>
		     </Breadcrumb>
             <div>
               <img src={'https://aquadeals.in/admin/assets/images/promo_offers/share_earn_bg.png'} alt="Share and Earn" width={"100%"} />
             </div>
           </div>   
           <div className="row ref_earn_code_blk">
              <div className="clr">&nbsp;</div>
              <div className="clr">&nbsp;</div>
              <div className="row" >
	            <div className="col-lg-4 col-md-4 col-sm-4 col-sm-offset-1 col-md-offset-1 text-center">
	               <h2 className="referral_earning"> &#8377;{this.state.tot_amt}</h2>
	               <h4>Total referral earnings</h4>
	             </div>
	             <div className="col-lg-4 col-md-4 col-sm-4 col-sm-offset-2 col-md-offset-2 text-center">
	               <h2 className="referral_code">{this.state.code}</h2>
	               <h4>Your referral code</h4>
	             </div>
	             <div className="col-lg-3 col-md-3 col-sm-3 col-sm-offset-2 col-md-offset-3">
	             </div>
              </div>
              <div className="clr">&nbsp;</div>
              <div className="clr">&nbsp;</div>
              <div className="row share_invite_blk">
                 <div className="col-lg-3 col-md-3 col-sm-3">
                    &nbsp;
                 </div>
                 <div className="col-lg-6 col-md-6 col-sm-6">
	               <div style={{clear:'both'}}>
				      <h4 className="web_share_invite_msg">Share and invite your friends</h4>
				      <Panel className="web_share_earn_panel text-center" id="web_share_earn_panel" collapsible expanded={this.state.open2}>
					     <FacebookShareButton url={url} title={title} className="web_test_earn_share outline">
			               <FacebookIcon size={50} round />
			             </FacebookShareButton>
			             <TwitterShareButton url={url} title={title} description={description} className="web_test_earn_share outline">
			               <TwitterIcon size={50} round />
			             </TwitterShareButton>
					     <GooglePlusShareButton url={url} title={title} descirption={description} className="web_test_earn_share outline">
			               <GooglePlusIcon size={50} round />
			             </GooglePlusShareButton>
		              </Panel>
				   </div>
                 </div>
                 <div className="col-lg-3 col-md-3 col-sm-3">
                   &nbsp;
                 </div>
              </div> 
           </div>
         </div>
         <WebFooter />
       </div> 
	);
  }
}


/** WEBPACK FOOTER **
 ** ./src/Desktop/components/Common/Web_Share_Earn.js
 **/